// extracted by mini-css-extract-plugin
export default {"count":"JRzhc","resultButton":"JO55U dim-button"};